export enum QuantityComparisonOption {
  NONE = 'NONE',
  EQUAL = 'EQUAL',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN = 'GREATER_THAN',
  BETWEEN = 'BETWEEN',
}
